namespace GeniuzPOS.PosShift {
    export namespace PsPosShiftControlViewService {
        export const baseUrl = 'PosShift/PsPosShiftControlView';

        export declare function Create(request: Serenity.SaveRequest<PsPosShiftControlViewRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPosShiftControlViewRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPosShiftControlViewRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPosShiftControlViewRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/PsPosShiftControlView/Create",
            Update = "PosShift/PsPosShiftControlView/Update",
            Delete = "PosShift/PsPosShiftControlView/Delete",
            Retrieve = "PosShift/PsPosShiftControlView/Retrieve",
            List = "PosShift/PsPosShiftControlView/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPosShiftControlViewService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
